<template>
  <StandardCardPageContainer v-if="!openStandardLayout">
    <h1>Design</h1>

    <v-tabs v-model="tab">
      <v-tab value="Typography">Typography</v-tab>
      <v-tab value="Components">Components</v-tab>
      <v-tab value="Widgets">Widgets</v-tab>
      <v-tab value="Layouts">Layouts</v-tab>
    </v-tabs>

    <v-card-text>
      <v-window v-model="tab">
        <v-window-item value="Typography" class="text-left">
          <h1>Header 1</h1>
          <h2>Header 2</h2>
          <h3>Header 3</h3>
          <h4>Header 4</h4>
          <h5>Header 5</h5>
          <p>Paragraph</p>

          <div class="appkit-component">Component</div>
          <div class="appkit-tooltip">Tooltip</div>
          <div>Body</div>
          <div class="appkit-data">Data</div>
        </v-window-item>
        <v-window-item value="Components">
          <h2>Buttons</h2>

          <div class="mt-5">
            <p class="mb-5">
              <PPrimaryButton>Primary Button</PPrimaryButton>
            </p>
            <p class="mb-5">
              <PSecondaryButton>Secondary Button</PSecondaryButton>
            </p>
            <p class="mb-5">
              <PTertiaryButton>Tertiary Button</PTertiaryButton>
            </p>
            <p class="mb-5">
              <PTextButton>Text Button</PTextButton>
            </p>
            <p class="mb-5">
              <PActionButton
                appkit-icon="icon-right-chevron-fill"
                :icon-size="'xs'"
                :append-icon="true"
                :loading="false"
                >Action Button</PActionButton
              >
            </p>
            <p class="mb-5">
              <p-primary-button :loading="true">
                Loading Button
              </p-primary-button>
            </p>
          </div>

          <h2>Checkbox</h2>
          <PCheckBox :value="true" label="Custom checkbox" />

          <h2>Boolean Input</h2>
          <PBooleanInput
            :boolean-options="booleanInputValue"
            @value-selected="setBooleanInputValue"
          />
          <h2>Modal boxes</h2>
          <div>
            <p class="mb-5">
              <PPrimaryButton @click="openModal1 = !openModal1"
                >Open modal 1</PPrimaryButton
              >
            </p>
            <p class="mb-5">
              <PPrimaryButton @click="openModal2 = !openModal2"
                >Open modal 2</PPrimaryButton
              >
            </p>
            <p class="mb-5">
              <PPrimaryButton @click="openModal3 = !openModal3"
                >Open modal 3</PPrimaryButton
              >
            </p>
            <p class="mb-10">
              <PPrimaryButton @click="openModal4 = !openModal4"
                >Open modal 4</PPrimaryButton
              >
            </p>
          </div>

          <PModalBox
            :open-dialog="openModal1"
            size="medium"
            header="Modal box"
            @close-dialog="openModal1 = false"
          >
            <template #content>
              <v-row>
                <v-col>
                  <PInputField value="" label="Name"></PInputField>
                </v-col>
                <v-col>
                  <PInputField value="" label="Email"></PInputField>
                </v-col>
              </v-row>
            </template>
            <template #rightbutton>
              <PPrimaryButton>Right Button</PPrimaryButton>
            </template>
          </PModalBox>

          <PModalBox
            :open-dialog="openModal2"
            size="large"
            header="Modal box"
            @close-dialog="openModal2 = false"
          >
            <template #content>
              <p>Please input your information in the boxes below.</p>
              <v-row>
                <v-col>
                  <PInputField value="" label="Name"></PInputField>
                </v-col>
                <v-col>
                  <PInputField value="" label="Email"></PInputField>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <PInputField value="" label="Country"></PInputField>
                </v-col>
                <v-col>
                  <PInputField value="" label="Industry"></PInputField>
                </v-col>
                <v-col>
                  <p>Yes or no?</p>
                  <PBooleanInput
                    :boolean-options="booleanInputValue"
                    @value-selected="setBooleanInputValue"
                  />
                </v-col>
              </v-row>
            </template>
            <template #leftbutton>
              <PPrimaryButton>Left Button</PPrimaryButton>
            </template>
            <template #rightbutton>
              <PPrimaryButton>Right Button 1</PPrimaryButton>
            </template>
          </PModalBox>

          <PModalBox
            :open-dialog="openModal3"
            size="small"
            header="Modal box"
            @close-dialog="openModal3 = false"
          >
            <template #content>
              <p>
                You have to create the grid structure of your content in your
                template. For example, creating a single narrow input field.
              </p>
              <v-row class="mt-2">
                <v-col cols="4">
                  <PInputField value="" label="Input"></PInputField>
                </v-col>
              </v-row>
            </template>
            <template #rightbutton>
              <PPrimaryButton>Ok</PPrimaryButton>
            </template>
          </PModalBox>

          <PModalBox
            :open-dialog="openModal4"
            header="Export modal box"
            @close-dialog="openModal4 = false"
            content-alignment="center"
          >
            <template #content>
              <p class="appkit-subheading">Choose export format</p>
              <div class="button-container">
                <PIconButton
                  appkit-icon="icon-download-cloud-outline"
                  href="/api/suppliers/export?exportType=1"
                >
                  Excel
                </PIconButton>
                <PIconButton
                  appkit-icon="icon-download-cloud-outline"
                  href="/api/suppliers/export?exportType=0"
                >
                  CSV
                </PIconButton>
              </div>
            </template>
          </PModalBox>
        </v-window-item>
        <v-window-item value="Widgets">
          <PMap :countries="mapCountries"></PMap>
        </v-window-item>
        <v-window-item value="Layouts">
          <PPrimaryButton @click="openStandardLayout = true"
            >Open Standard Layout</PPrimaryButton
          >
        </v-window-item>
      </v-window>
    </v-card-text>
  </StandardCardPageContainer>
  <StandardLayoutHelperView
    v-if="openStandardLayout"
  ></StandardLayoutHelperView>
</template>

<script setup lang="ts">
import PPrimaryButton from "@/components/custom/buttons/PPrimaryButton.vue";
import PSecondaryButton from "@/components/custom/buttons/PSecondaryButton.vue";
import PCheckBox from "@/components/custom/PCheckBox.vue";
import PBooleanInput from "@/components/custom/PBooleanInput.vue";
import StandardCardPageContainer from "@/components/containers/StandardCardPageContainer.vue";
import PMap from "@/components/widgets/PMap.vue";
import { ref } from "vue";
import { BooleanOption } from "@/models/questions/booleanOption";
import PActionButton from "@/components/custom/buttons/PActionButton.vue";
import PModalBox from "@/components/custom/PModalBox.vue";
import PInputField from "@/components/custom/PInputField.vue";
import PIconButton from "@/components/custom/buttons/PIconButton.vue";
import PTertiaryButton from "@/components/custom/buttons/PTertiaryButton.vue";
import PTextButton from "@/components/custom/buttons/PTextButton.vue";
import StandardLayoutHelperView from "@/views/Design/StandardLayoutHelperView.vue";

const tab = ref("");
const mapCountries = new Array<string>("NO", "GB", "ZW");
const openStandardLayout = ref(false);

const openModal1 = ref(false);
const openModal2 = ref(false);
const openModal3 = ref(false);
const openModal4 = ref(false);

const booleanInputValue = ref(
  new Array<BooleanOption>(
    new BooleanOption("yes", "Yes"),
    new BooleanOption("no", "No")
  )
);

function setBooleanInputValue(newBoolean: string): void {
  booleanInputValue.value.forEach((x) => {
    x.checked = x.id == newBoolean;
  });
}
</script>
